import { formatDecimal as formatDecimalDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatNumberProps = {
    value: number;
    decimals: number;
}

export const formatDecimal = ({ value, decimals }: FormatNumberProps): string =>
    formatDecimalDiagram(value, decimals);
